import {useCallback, useState} from 'react'

export const useMergeState = (def = {}) => {
	const [state, setState] = useState(def)
	const setMergeState = useCallback(newState => setState(prev => ({...prev, ...newState})), [])
	return [state, setMergeState, setState]
}
